const CONSTANTS = {
  USER_TOKEN_KEY: "userToken",
  SAVE_CONTINUE: "Save & Continue",
  SEND_CONTINUE: "Send & Continue",
  VERIFY_YOUR_IDENTITY: "Verify your identity",
  VERIFY_IDENTITY: "Verify identity",
  VERIFY_REGISTRATION: "Verify registration",
  VERIFY_ROW: "verify-row",
  UPLOAD_DOCUMENTS: "Upload documents",
  UPLOAD_SUCCESS: "Upload successful",
  UPLOAD_FAILURE: "Not uploaded",
  YES: "Yes",
  NO: "No",
  NEXT: "Next",
  REMOVE: "Remove",
  DELETE: "Delete",
  BACK: "Back",
  CANCEL: "Cancel",
  CLOSE: "Close",
  SUBMIT: "Submit",
  SUBMIT_APPLICATION_BUTTON: "Submit Application",
  ADD_ANOTHER: "Add",
  DATE_FORMAT: "MM/DD/YYYY",
  DATE_FORMAT_ISO_8601: "YYYY-MM-DD",
  MIN_YEAR: "18yrs",
  DEFAULT_DATE_FORMAT: "MM/dd/yyyy",
  DEFAULT_DATE_FORMAT_FUNDRAISING: "MM/yyyy",
  MMM_YYYY_FORMAT: "MMM yyyy",
  DEFAULT_MIN_DATE: "01/01/1900",
  DEFAULT_MAX_DATE: "01/01/2100",
  INVALID_DATE_MSG: "Invalid Date",
  JOURNEY_IN_PROGRESS: "In Progress",
  TASK_IN_PROGRESS: "In Progress",
  TASK_NOT_STARTED: "Not Started",
  CLIENT: "Client",
  RELATED_PARTY: "Related Party",
  INDIVIDUAL: "Individual",
  COMPANY: "Company",
  APPLICANT: "Applicant",
  CLIENT_IDV_CATEGORIES: [
    "Verification Document",
    "Formation Document",
    "Second formation document",
    "Address Document",
    "Tax Document",
    "EIN Document",
    "Name verification document",
  ],
  POLICY_TYPE_DATA: "Data",
  PERCENTAGE_OWNERSHIP: "percentageOwnership",
  RELATIONSHIP: "relationship",
  SHOW_ACCORDION_LAYOUT: false,
  USE_DIALOG_FOR_ADD_RELATED_PARTY: true,
  INPUT_MAX_LENGTH: 255,
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  SVB_EMAIL_REGEX: /@svb\.com$/,
  GENERIC_FIELD_REQUIRED_MESSAAGE: "This field is required.",
  GENERIC_FILE_REQUIRED_MESSAAGE: "This file is required.",
  IDV_STATUS_FAILED_MESSAGE: "Please check if all the documents are uploaded.",
  DATA_GROUP_FIELD_CONTENT: [],

  TRUE: "True",
  FALSE: "False",
  SVB_WEBSITE: "https://www.svb.com",
  RETURN_TO_SVB: "Return to SVB.com",
  LENDX_SUPPORT: "LendX Support",
  LENDX_SUPPORT_EMAIL: "lendxappsupport@firstcitizens.com",
  TRY_AGAIN: "Try Again",

  MFA: {
    RESEND_CODE_RETRIES: 3,
    // Count down starts from this number
    COUNT_DOWN_START_TIME_SECONDS: 60,
    // Interval that indicates how often the timer will update
    COUNT_DOWN_INTERVAL_SECONDS: 1,
  },
  PENDING_EIN: "Pending EIN",
  UNITED_STATES: "United States",
  UNITED_KINGDOM: "United Kingdom",
  FIRST_CITIZENS_LOGIN: "https://lendx.firstcitizens.com",
  OKAY: "Okay",
  ESIGN: "E-Sign",
  ADD_PARTY: "Add Party",
  OUTLINE_LABEL_COMPONENTS: ["text", "number", "date"],
  DOCUSIGN: {
    COMPLETED: "completed",
  },

  // How much time is left in the existing User JWT Token before a SessionAlive request is made
  // e.g. With constant user activiy, a SessionAlive request will be made every 5 minutes assuming the
  //  standard JWT token has a timeout of 30 minutes and this is set to 25 minutes
  REFRESH_BUFFER_DURATION_SECONDS: 25 * 60, // 25 minutes
  // How long before an idle user times out, this will trigger logout
  IDLE_TIMEOUT_DURATION: 30 * 60_000, // 30 minutes
  // The duration before IDLE_TIMEOUT_DURATION when a user is prompted that their session is about to expire
  PROMPT_BEFORE_IDLE_DURATION: 60_000,
  // How often to fire events
  // e.g. With constant user activity and a value of 6_000, the onAction event would be called once every 6 seconds
  EVENT_THROTTLE_DURATION: 10_000,

  REVIEW_AND_ATTEST: "Review and Attest",
  REVIEW_AND_SUBMIT: "Review and Submit",
  SUBMIT_APPLICATION: "Submitting Application",
  SAVING_DATA: "Saving Data...",
  FIXED_HELP_TOOLTIP_COMPONENTS: ["text", "number", "date", "select", "multiselect"],
  IGNORABLE_FIELDS: [
    "ifTheresAnythingAccountingRelatedYoudLikeUsToKnowUseTheSpaceBelow",
    "tellUsAboutYourOwnMilestonesDisclaimer",
    "toExpediteYourApplicationTakeAMomentToReviewAndConfirmYourInformation",
    "pleaseNoteSiliconValleyBankDepositAccountDisclaimer",
    "loanApplicationAttestation",
    "mstone1",
    "mstone2",
    "dateOfLastRound",
    "doYouPlanOnRaisingAnotherRoundOfFunding",
    "reviewAndSubmitDisclosureStatement1",
    "reviewAndSubmitDisclosureStatement2",
    "headquartersAddressTitle",
    "generalPartner",
    "otherDocuments",
    "additionalAnnualRevenueFromAffiliates",
    "platformName",
  ],
  FISCAL_YEAR_END_DATE_ERROR_MSG: "Last fiscal year-end date must be less than a year old",
  CONSENT_ACCEPTED_DATE_TIME_LOCALSTORAGE_KEY: "consentAcceptedDateTime",
  DLA: "DLA",
  ADF: "ADF",
  DLA_MAX_RETRIES: 2,
  DLA_RETRY_DELAY: 500,
  DLA_DEBOUNCE_DELAY: 500,
  INTERNAL_USER_ROLES: ["admin", "credit_analysis", "credit_solutions", "relationship_management", "cs_cards"],
  ACCOUNT_BUCKETS: {
    UNBUCKETED_ACCOUNTS: `This client has unbucketed accounts that require bucketing.`,
    REFRESH_WORKBOOK_DESC: `Changes to account buckets have been saved but will not be reflected in the current workbook until the spread has been refreshed.`,
    WORKBOOK_REFRESHING: `Refreshing Pro Forma Spread`,
    WORKBOOK_REFRESHING_DESC: `This will take 2-5 minutes. Changes to account buckets cannot be made during this time.`,
    WORKBOOK_REFRESHED: (dateTime: string) => `Pro Forma Spread Refreshed (${dateTime})`,
    WORKBOOK_REFRESH_STATUS: {
      IN_PROGRESS: "IN_PROGRESS",
      COMPLETED: "COMPLETED",
      INITIAL_STATE: "",
    },
    SEARCH_TEXT: "Use this tab to update existing account buckets and/or any new accounts added by the borrower.",
    REFRESH_CONFIRMATION: {
      BODY1: `Changes to account buckets have been saved but will not be reflected in the current workbook until it's been refreshed.`,
      BODY2: "Are you sure you wish to leave without refreshing?",
    },
    REFRESH_BUTTON_DESC: `REFRESH PRO FORMA SPREAD`,
    REFRESH_WORKBOOK_DESC_FOR_NO_WB_CURRENT_MONTH: `Changes to account buckets have been saved but there isn't a workbook for the current reporting month.`
  },
  WORKBOOK_MANAGEMENT: {
    WORKBOOK_REFRESHED: (dateTime: string) => `Pro Forma Spread Refreshed (${dateTime})`,
  },
  EXTERNAL_SYSTEMS: {
    COMPLAINCE_TRACKER: "Compliance_Tracker",
    CREDIT_LENS: "CreditLens",
  },
  DB_PLATFORM: {
    POSTGRES: "POSTGRES",
    DYNAMO: "DYNAMO",
    NONE: "NONE",
  },
  TOOLTIP_TITLES: {
    PDSINELIGIBILE:
      "This prospective client’s financials cannot be spread because it either isn’t properly set up in CreditLens, has duplicate CRM Entity IDs, or it’s Relationship Type has been set to Customer in CreditLens.",
    PDSUNAVAILABLE: 
      "The Direct Spreading Eligibility is unknown due to Moody CreditLens not responding. Try reloading the page. If the issue persists, contact LendX App Support.",
    MONTHLY_REMINDER_EMAIL:
      "Sends a reminder email to the client 5  <br/ >business days before we automatically  <br/ >pull their financials.",
    MONTHLY_REMINDER_EMAIL_STATUS:
      "A primary or secondary email must be added in order to enable the monthly reminder email.",
    CRM_ENTITY_ID:
      "Blank CRM IDs can be completed by CA/CS. If a CRM ID <br />needs to be updated, contact LendX Support.",
    BOOK_CLOSURE_SEVERITY:
      "Low: All indicators have 0% variance <br/ >Medium: At least 1 indicator, or restatement, with absolute variance >0% but less than 10% <br />High: At least 1 indicator, or restatement, with absolute variance greater than or equal to 10%",
    BOOK_CLOSURE_NON_ZERO_ACC:
      "Compares the client’s current number of non-zero <br/ >accounts to their average over the past 2 months.",
    BOOK_CLOSURE_RESTATEMENT:
      "Shows number of major lines that had a variance when <br/ >comparing last reporting month as reported last month to <br/ >last reporting month as reported this month.",
    BOOK_CLOSURE_BURN_RATE:
      "Compares the current month’s change in 1050 - Cash to <br/ >the burn rate. Expressed relative to the past 2 month <br/ >average.<br/ ><br/ >Current month ΔCash: –$1,500,000<br/ >Current month Burn Rate: $16,000<br/ >Difference: –9,300%<br/ ><br/ >T2M ΔCash: +$30,000<br/ >T2M Average Burn Rate: $15,000<br/ >Difference: 200%",
    BOOK_CLOSURE_CASH_DIFFERENCE:
      "Compares the reported cash balance in the company’s <br/ >balance sheet to the cash balance recorded at SVB. <br/ >Expressed relative to the past 2 month average.<br/ ><br/ >Current month Bal Sheet Cash: $1,500,000/ >Current month SVB Cash: $1,500,000<br/ >Difference: $0<br/ ><br/ >T2M Bal Sheet Cash: $1,400,000<br/ >T2M SVB Cash: $1,400,000<br/ >Difference: $0",
    BOOK_CLOSURE_PROJECTED_DATE: "Last Projected Close Date as calculated by Codat",
    SVB_CASH_ACCOUNT:
      "Balance Sheet accounts are from 1050-Cash/1055- <br/ >Restricted Cash. Update the account buckets if any <br />accounts are missing or if there are accounts that should <br />not be included.",
    LOAN_ACCOUNT_HEADER_TOOLTIP: `Balance Sheet accounts are from:<ul style="padding-left: 18px;"><li>3800 - Other Accruals</li><li>3165 - CPLTD-SVB</li><li>3100 - ST Loans Payable-SVB</li><li>4050 - Long Term Debt-SVB</li></ul><br />Update the account buckets if any accounts are missing or<br/> if there are accounts that should not be included.`,
    NO_MATCH_SVB_TOOL_TIP: `Potential reasons:<ul><li>Account is missing in SVB’s data </li><li> Account has been closed </li></ul>`,
    NO_MATCH_LOAN_ACC_BS_TOOLTIP: `Potential reasons:<ul><li>Account is missing from workbook</li><li>Account has been closed</li></ul>`,
    NO_MATCH_CASH_ACC_BS_TOOLTIP: `Potential reasons:<ul><li>Account is missing in Balance Sheet</li><li>Account has been closed</li></ul>`,
  },
  EMAIL: {
    GROUP_LENDX_APPLICATION_SUPPORT: "grouplendxapplicationsupport@svb.com",
  },
  BOOK_CLOSURE_DASHBOARD: {
    HEADER_TEXT:
      "This dashboard compares the current and prior reporting months to help determine whether the borrower’s books are closed.",
    SEVERITY_LEVELS: ["ANY", "LOW", "MEDIUM", "HIGH"],
  },
  ADF_STATUSES: {
    IN_PROGRESS: "Not started",
    COMPLETED: "Completed",
  },
  ACCOUNT_TYPE: {
    LOAN_ACCOUNT: "loan_account",
    CASH_ACCOUNT: "cash_account",
  },
  WATCHLIST: {
    ISSUES: {
      CONNECTION_ISSUES: "Connection Issues",
      MISSING_WORKBOOK: "Missing Workbooks",
      UNBUCKETED_ACCOUNTS: "Unbucketed Accounts",
      UNMATCHED_ACCOUNTS: "Unmatched Accounts",
      BOOKS_CLOSURE: "Books may not be closed",
    },
  },
  FDM_DASHBOARD: {
    DISPLAY_HIDDEN_COMPANIES: "Show Hidden Companies",
    SHOW_INACTIVE_COMPANIES: "Show Inactive Companies",
    "disconnection-management": "Disconnection Management",
    "view": "Companies",
    "book-closure-dashboard": "Books Closure Dashboard",
    TAB_CONFIGS: {
      COMPANIES: { label: "COMPANIES", value: "companies" },
      BOOKCLOSURE: { label: "BOOK CLOSURE DASHBOARD", value: "bookClosure" },
      PORTFOLIO: { label: "MY PORTFOLIO", value: "portfolio" },
      WATCHLIST: { label: "WATCHLIST", value: "watchlist" },
      ALL_COMPANIES: { label: "ALL COMPANIES", value: "allCompanies" },
    },
  },
  DISCONNECTION_MANAGEMENT_FILTERS: {
    ACTION_REQUIRED: "actionRequired",
    ACTIONED: "actioned",
  },
  USER_LIST_FILTERS: {
    ACTIVE: "active",
    IN_ACTIVE: "inactive",
  },
  FLAG_CODES: {
    all_credit_packages_complete:
      "All Credit Packages Complete: This company does not have any active Credit Packages. As accounting software connections are not permitted for clients without active Credit Packages, please deactivate their accounting connection by setting them to Inactive.",
    client_status_mismatch:
      "Client Status Mismatch: This company's status in Compliance Tracker (i.e. Inactive) does not match the status we have in LendX (i.e. Active). Unless the company is in the process of renewing their loan, please set their status to “Inactive”.",
    corp_banking_team_code:
      "Unauthorized Team Code: This company is a corporate banking client (team code 18F). As accounting software connections are not permitted for corporate banking clients, please deactivate their accounting connection by setting them to Inactive.",
    team_code_mismatch:
      "Team Code Mismatch: This company's team code in Compliance Tracker (i.e. 12A) and/or nCino (i.e. 12A) does not match the team code we have in LendX (i.e. 14B). Please reconcile. ",
    stale_connection:
      "Stale Connection: This company's workbook hasn't been refreshed in the last 91 days. Please review the last refresh date and any other actions taken on the company to determine if it should be set to Inactive.",
    abandoned_connection:
      "Abandoned Connection: This company abandoned connecting their accounting software to SVB. The company has been set to Inactive.",
    customer_request:
      "Customer Request: This company requested to be disconnected.",
    other:
      "Specified Reason: Ad-hoc disconnection completed."
  },
  CREDITLENS_SELECT_MONTH_TOOLTIP:
    "If you choose a previous month that already has data, CreditLens will duplicate that month's column, label the copy as “Restated”, and populate it with the updated financials.\n\nIf there's no data for that month, it will simply populate the 1st spread as usual, without the “Restated” label.",
  CREDITLENS_SPREAD_STATUS_TOOLTIP:
    "Identifies if a spread exists, specifying whether it’s the 1st spread or a restatement.",
  DOCUMENT_POLICY: {
    OTHER_DOC_TEXT:
      "If there are other documents you think might provide us with a more complete picture of your company, feel free to upload those documents below (eg. Convertible Notes, Recurring Revenue metrics, SaaS metrics, other KPI Reports, etc.)",
  },
  SUPPORT_EMAIL: "LendXAppSupport@FirstCitizens.com",
  HELP_LINKS: {
    USER_GUIDE: {
      label: "LendX User Guide",
      url: "https://firstcitizens.sharepoint.com/:b:/s/CreditManagementExperience/IQAbZu0QGPMCQ6tvyRddjrVPAUaAY8hfH84Zmm-cXbbWAEU?e=lbiDOL",
    },
    WORKBOOK_GUIDE: {
      label: "LendX Financial Workbook Guide",
      url: "https://firstcitizens.sharepoint.com/:b:/s/CreditManagementExperience/IQCKXIUsPYmHQr3KL7MtRHo-AeW3v7XcTgS9fu9GHY8rRMc?e=LPDlQD",
    },
  }
};

export default CONSTANTS;
